<template>
  <b-modal
    id="welcomeModalFree"
    content-class="ax-modal-transparent"
    centered
    hide-footer
    hide-header
    hide-actions
    no-close-on-backdrop
    :size="size">
    <section class="c-modal c-modal--dark-blur">
      <div
        class="c-modal__dialog"
      >
        <section
          class="p-4">
          <div class="d-flex flex-column align-items-center text-center">
            <h3 class="w-bold fs-25 white">¡Bienvenido a tu curso gratis!</h3>
            <p class="mb-5">
              <template v-if="isCourseLimitedFree">
                ¡Recuerda que tu acceso gratuito es válido por tiempo limitado!
              </template>
              <template v-else>
                Para continuar es necesario completar tus datos
              </template>
            </p>

            <template v-if="isCourseLimitedFree">
              <Timer v-if="dateEnd" :end="dateEnd" class="mb-3" />

              <p class="mb-5 medium-gray">
                A nadie le gusta los limites, con un solo pago accede a este y
                <span class="w-bold white">más de 100 cursos.</span>
                <a href="/planes" class="c-link c-link--primary ms-1">Ver planes</a>
              </p>

              <button
                @click="startCourse()"
                class="c-button c-button--primary"
              >
                Empezar curso
              </button>
            </template>
            <template v-else>
              <EditForm
                ref="editFormProfile"
                color="dark"
                :isUpdating.sync="isUpdating"
                :isChanged.sync="isChanged"
                :handleSuccess="handleSuccess"
                :handleError="handleError"
              >
                <template v-slot:actions>
                  <div class="d-flex justify-content-end align-items-center">
                    <button
                      @click="$refs.editFormProfile.updateProfile()"
                      class="c-button c-button--primary small ms-3"
                      :class="{loading : isUpdating}"
                      :disabled="isUpdating || !isChanged"
                    >
                      {{
                        (isUpdating) ? 'Actualizando...' : 'Guardar cambios'
                      }}
                      <img
                        class="c-button__spinner"
                        src="@/assets/images/animations/spinner-white.png"
                        alt="loading"
                      />
                    </button>
                  </div>
                </template>
              </EditForm>
            </template>
          </div>
        </section>
      </div>
    </section>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      size: 'md',

      isUpdating: false,
      isChanged: false,
    };
  },
  props: {
    course: Object,
    player: Object,
  },
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
    }),

    isCourseLimitedFree() {
      return this.course.access?.plan === 'free' && this.course.access?.expiration?.date_full;
    },
    isCourseCompleteFree() {
      return this.course.access?.plan === 'free' && !this.course.access?.expiration?.date_full;
    },
    isCompleteProfile() {
      return false;
    },

    dateEnd() {
      return this.course.access?.expiration?.date_full;
    },
  },
  components: {
    Timer: () => import(/* webpackChunkName: "timer" */'@/components/Timer.vue'),
    EditForm: () => import(/* webpackChunkName: "edit-form" */'@/components/profile/EditForm.vue'),
  },
  mounted() {
    this.configModal();

    if (this.course.progress && this.course.progress.percentage === 0) {
      if (this.isCourseLimitedFree) {
        this.stopCourse();
      } else if (this.isCourseCompleteFree) {
        this.checkCompleteProfile();
      }
    }
  },
  methods: {
    configModal() {
      if (this.isCourseCompleteFree) {
        this.size = 'lg';
      }
    },

    startCourse() {
      this.player.play();
      this.$bvModal.hide('welcomeModalFree');
    },
    stopCourse() {
      this.player.pause();

      this.$bvModal.show('welcomeModalFree');
    },

    handleSuccess() {
      this.startCourse();
    },
    handleError() { },

    checkCompleteProfile() {
      fetch(`${window.arcux.api}/users/${this.userData.id}/profile`, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            if (
              !response.data.date_born
              || !response.data.dni
              || !response.data.field_study
              || !response.data.first_name
              || !response.data.last_name
              || !response.data.genre
              || !response.data.level_education
              || !response.data.mobile
              || !response.data.university
            ) {
              this.stopCourse();
            }
          }
        })
        .catch(() => {});
    },
  },
};
</script>
